<template>
  <div class="users">
    <div class="div-titulo">
      <div>
        <h3 class="intern-title ml-3">
          <back-arrow />
          <span class="page-nav"
            >Editar Ordem De serviço {{ OsInfo.ordem_servico_id }}</span
          >
        </h3>

        <div>
          <span
            v-if="OsInfo.ordem_servico_status_descricao === 'Em Criação'"
            class="em-criacao status_editar"
          >
            {{ OsInfo.ordem_servico_status_descricao }}
          </span>
          <span
            v-if="OsInfo.ordem_servico_status_descricao === 'Revisar'"
            class="revisar status_editar"
          >
            {{ OsInfo.ordem_servico_status_descricao }}
          </span>
          <span
            v-if="OsInfo.ordem_servico_status_descricao === 'Finalizada'"
            class="finalizada status_editar"
          >
            {{ OsInfo.ordem_servico_status_descricao }}
          </span>
          <span
            v-if="OsInfo.ordem_servico_status_descricao === 'Cancelada'"
            class="revisar status_editar"
          >
            {{ OsInfo.ordem_servico_status_descricao }}
          </span>
          <span
            v-if="OsInfo.ordem_servico_status_descricao === 'Em Andamento'"
            class="andamento status_editar"
          >
            {{ OsInfo.ordem_servico_status_descricao }}
          </span>
          <span
            v-if="OsInfo.ordem_servico_status_descricao === 'Revisado'"
            class="andamento status_editar"
          >
            {{ OsInfo.ordem_servico_status_descricao }}
          </span>
          <span
            v-if="OsInfo.ordem_servico_status_descricao === 'Em Análise'"
            class="andamento status_editar"
          >
            {{ OsInfo.ordem_servico_status_descricao }}
          </span>
          <span
            v-if="OsInfo.ordem_servico_status_descricao === 'Avaliar'"
            class="finalizada status_editar"
          >
            {{ OsInfo.ordem_servico_status_descricao }}
          </span>
          <span
            v-if="OsInfo.ordem_servico_status_descricao === 'Re-Execução'"
            class="andamento status_editar"
          >
            {{ OsInfo.ordem_servico_status_descricao }}
          </span>
        </div>
      </div>

      <div
        v-if="
          OsInfo.ordem_servico_status_descricao === 'Em Criação' ||
          OsInfo.ordem_servico_status_descricao === 'Revisar'
        "
      >
        <div
          v-if="userType === 2 || this.userType === 3 || this.userType === 1"
          class="div-cancelar"
        >
          <button
            class="botao-cancelar-solicitacao"
            @click="ShowModalCancelar()"
          >
            Cancelar Solicitação
          </button>
        </div>
      </div>
    </div>

    <div v-if="historicos != ''" class="historico-Os ml-3">
      <h3 class="nova-ordem-titulo">Histórico da Ordem de Serviço</h3>
      <div
        v-for="log of historicos"
        :key="log.ordem_servico_log_id"
        class="historico-loop"
      >
        <div class="historico-data">
          {{ formatDate(log.ordem_servico_log_data) }}
        </div>
        <div class="historico-card">
          <div class="historico-usuario">
            <span class="historico-nome">{{ log.usuario_gestor_nome }}</span>
            <span class="historico-descricao">Alterou o status</span>
            <div>
              <span
                v-if="log.ordem_servico_status_descricao === 'Em Criação'"
                class="em-criacao status_historico"
              >
                {{ log.ordem_servico_status_descricao }}
              </span>
              <span
                v-if="log.ordem_servico_status_descricao === 'Revisar'"
                class="revisar status_historico"
              >
                {{ log.ordem_servico_status_descricao }}
              </span>
              <span
                v-if="log.ordem_servico_status_descricao === 'Finalizada'"
                class="finalizada status_historico"
              >
                {{ log.ordem_servico_status_descricao }}
              </span>
              <span
                v-if="log.ordem_servico_status_descricao === 'Cancelada'"
                class="revisar status_historico"
              >
                {{ log.ordem_servico_status_descricao }}
              </span>
              <span
                v-if="log.ordem_servico_status_descricao === 'Em Andamento'"
                class="andamento status_historico"
              >
                {{ log.ordem_servico_status_descricao }}
              </span>
              <span
                v-if="log.ordem_servico_status_descricao === 'Revisado'"
                class="andamento status_historico"
              >
                {{ log.ordem_servico_status_descricao }}
              </span>
              <span
                v-if="log.ordem_servico_status_descricao === 'Em Análise'"
                class="andamento status_historico"
              >
                {{ log.ordem_servico_status_descricao }}
              </span>
              <span
                v-if="log.ordem_servico_status_descricao === 'Avaliar'"
                class="finalizada status_historico"
              >
                {{ log.ordem_servico_status_descricao }}
              </span>
              <span
                v-if="log.ordem_servico_status_descricao === 'Re-Execução'"
                class="andamento status_historico"
              >
                {{ log.ordem_servico_status_descricao }}
              </span>
            </div>
          </div>
          <div class="historico-log-info">
            <h3 v-if="!log.ordem_servico_log_info" class="log-info">
              {{ log.ordem_servico_log_info }}
            </h3>
          </div>
        </div>
      </div>
    </div>

    <div class="nova-ordem ml-3">
      <h3 class="nova-ordem-titulo">Selecione uma Atividade</h3>
      <select
        @change="change()"
        class="atividade-input"
        v-model="atividade"
        type="text"
      >
        <option :value="atividade" disabled>
          {{ atividade.atividade_nome }}
        </option>
        <option :value="item" v-for="(item, id) of atividades" :key="id">
          {{ item.atividade_nome }}
        </option>
      </select>
    </div>

    <div class="nova-ordem ml-3">
      <h3 class="nova-ordem-titulo">Instruções</h3>
      <textarea
        @change="change()"
        placeholder="Digite aqui as instruções da ordem de serviço ..."
        class="instrucoes-input"
        v-model="instrucoes"
        type="text"
      ></textarea>
    </div>

    <div class="nova-ordem">
      <h3 class="nova-ordem-titulo">Buscar Endereço</h3>
      <input
        @change="change()"
        placeholder="Digite um endereço válido"
        class="atividade-input"
        v-model="endereco"
        type="text"
      />
    </div>
    <div
      v-if="userType === 2 || this.userType === 3 || this.userType === 1"
      class="nova-ordem"
    >
      <button id="exibir1" @click="exibir()" class="exibir">
        {{ $t("ShowUp") }}
      </button>
    </div>

    <!-- Caminho infeliz ---------------------------------------------------------------------------------------------------------------------------------------->

    <div v-if="exibirErro === true" class="erro-exibir">
      <div class="erro-endereco">
        <div class="barra-vermelha"></div>
        <img class="x-vermelho" src="../../assets/img/erro.png" alt="erro" />
        <div>
          <h3 class="nova-ordem-erro">
            O endereço indicado não foi encontrado.
          </h3>
          <h3 class="nova-ordem-erro2">
            Selecione a área de zeladoria manualmente a partir da busca por
            bairro.
          </h3>
        </div>
      </div>

      <div class="nova-ordem">
        <h3 class="nova-ordem-titulo">Selecione um bairro</h3>
        <select
          @change="change2()"
          class="atividade-input"
          v-model="bairro"
          type="text"
        >
          <option value="0" disabled>Selecione um Bairro</option>
          <option :value="item" v-for="(item, id) of bairros" :key="id">
            {{ item.bairro_nome }}
          </option>
        </select>
      </div>
      <div class="nova-ordem">
        <button id="exibir2" @click="exibir2()" class="exibir" disabled>
          {{ $t("ShowUp") }}
        </button>
      </div>
    </div>

    <div v-if="exibirDiv === true" class="informacoes-exibir">
      <div class="box-zeladdoria">
        <div class="os-info">
          <h3 class="nova-ordem-titulo">Zeladoria Atribuída</h3>
          <div
            v-if="infoZeladoria.zeladoria_nome != null"
            class="zeladoria-atribuida"
          >
            {{ this.infoZeladoria.zeladoria_nome }}
          </div>
          <div v-else class="zeladoria-atribuida">AAA000</div>

          <h3 class="nova-ordem-titulo">Zelador Atribuído</h3>
          <div class="foto-nome">
            <!--<img v-if="this.infoZeladoria.usuario_foto != null" class="os-avatar" :src="infoZeladoria.usuario_foto" alt="zelador">-->
            <!--<img v-else class="os-avatar" src="../../assets/img/face.png" alt="zelador">-->
            <h3 v-if="infoZeladoria.usuario_nome != null" class="nome-zelador">
              {{ this.infoZeladoria.usuario_nome }}
            </h3>
            <h3 v-else class="nome-zelador">Zelador</h3>
          </div>

          <h3 class="nova-ordem-titulo">Monitor Atribuído</h3>
          <div class="foto-nome">
            <h3
              v-if="infoZeladoria.usuario_gestor_nome != null"
              class="nome-zelador"
            >
              {{ this.infoZeladoria.usuario_gestor_nome }}
            </h3>
            <h3 v-else class="nome-zelador">Monitor</h3>
          </div>
        </div>
        <div class="os-map">
          <GmapMap
            class="map"
            ref="googleMap"
            :center="center"
            :zoom="zoom"
            style="height: 278px; width: 800px"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              mapTypeId: mapType,
              gestureHandling: 'greedy',
              fullscreenControl: true,
              disableDefaultUi: true,
              mapTypeId: mapType,
            }"
          >
            <!-- click aqui -> função -->
            <div
              v-for="polygon of polygonSector"
              :key="'polygonsKeepingSector' + polygon.id"
            >
              <GmapPolygon
                @click="poligonClick(polygon)"
                ref="polygon"
                :paths="polygon.latlngs"
                :options="polygon.options"
              />
            </div>
            <GmapPolyline
              ref="polyline"
              v-if="polyline !== null"
              :path="polyline.latlngs"
              :options="polyline.options"
            />
          </GmapMap>
        </div>
      </div>
      <div
        v-if="
          OsInfo.ordem_servico_status_descricao === 'Em Criação' ||
          OsInfo.ordem_servico_status_descricao === 'Revisar'
        "
      >
        <div
          v-if="userType === 2 || this.userType === 3 || this.userType === 1"
          class="botoes-solicitar-os"
        >
          <button @click="ShowModalRascunho()" class="salvar-rascunho">
            Salvar Rascunho
          </button>
          <button @click="ShowModalEnviar()" class="exibir">Enviar</button>
          <div v-if="alertaPoligono === true" class="alertErro">
            *Selecione uma Área de Zeladoria no mapa*
          </div>
        </div>
      </div>
    </div>

    <!-- Caminho feliz ---------------------------------------------------------------------------------------------------------------------------------------->

    <div v-if="exibirSucesso === true" class="informacoes-exibir">
      <div class="box-zeladdoria">
        <div class="os-info">
          <h3 class="nova-ordem-titulo">Zeladoria Atribuída</h3>
          <div
            v-if="infoZeladoria.zeladoria_nome != null"
            class="zeladoria-atribuida"
          >
            {{ this.infoZeladoria.zeladoria_nome }}
          </div>
          <div v-else class="zeladoria-atribuida">AAA000</div>

          <h3 class="nova-ordem-titulo">Zelador Atribuído</h3>
          <div class="foto-nome">
            <!--<img v-if="this.infoZeladoria.usuario_foto != null" class="os-avatar" :src="infoZeladoria.usuario_foto" alt="zelador">-->
            <!--<img v-else class="os-avatar" src="../../assets/img/face.png" alt="zelador">-->
            <h3 v-if="infoZeladoria.usuario_nome != null" class="nome-zelador">
              {{ this.infoZeladoria.usuario_nome }}
            </h3>
            <h3 v-else class="nome-zelador">Zelador</h3>
          </div>

          <h3 class="nova-ordem-titulo">Monitor Atribuído</h3>
          <div class="foto-nome">
            <h3
              v-if="infoZeladoria.usuario_gestor_nome != null"
              class="nome-zelador"
            >
              {{ this.infoZeladoria.usuario_gestor_nome }}
            </h3>
            <h3 v-else class="nome-zelador">Monitor</h3>
          </div>
        </div>
        <div class="os-map">
          <GmapMap
            class="map"
            ref="googleMap"
            :center="center"
            :zoom="zoom"
            style="height: 278px; width: 800px"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              mapTypeId: mapType,
              gestureHandling: 'greedy',
              fullscreenControl: true,
              disableDefaultUi: true,
              mapTypeId: mapType,
            }"
          >
            <div
              v-for="polygon of polygonSector"
              :key="'polygonsKeepingSector' + polygon.id"
            >
              <GmapPolygon
                ref="polygon"
                :paths="polygon.latlngs"
                :options="polygon.options2"
              />
            </div>
            <GmapPolyline
              ref="polyline"
              v-if="polyline !== null"
              :path="polyline.latlngs"
              :options="polyline.options"
            />
          </GmapMap>
        </div>
      </div>
      <div
        v-if="
          OsInfo.ordem_servico_status_descricao === 'Em Criação' ||
          OsInfo.ordem_servico_status_descricao === 'Revisar'
        "
      >
        <div
          v-if="userType === 2 || this.userType === 3 || this.userType === 1"
          class="botoes-solicitar-os"
        >
          <button @click="ShowModalRascunho()" class="salvar-rascunho">
            Salvar Rascunho
          </button>
          <button @click="ShowModalEnviar()" class="exibir">Enviar</button>
          <div v-if="this.alertaPoligono === true" class="alertErro">
            *Selecione uma Área de Zeladoria no mapa*
          </div>
        </div>
      </div>
    </div>

    <!-- Caminho Neutro ------------------------------------------------------------------------------------------------------------------------------>

    <div v-if="exibirNeutro === true" class="informacoes-exibir">
      <div class="box-zeladdoria">
        <div class="os-info">
          <h3 class="nova-ordem-titulo">Zeladoria Atribuída</h3>
          <div
            v-if="infoZeladoria.zeladoria_nome != null"
            class="zeladoria-atribuida"
          >
            {{ this.infoZeladoria.zeladoria_nome }}
          </div>
          <div v-else class="zeladoria-atribuida">AAA000</div>

          <h3 class="nova-ordem-titulo">Zelador Atribuído</h3>
          <div class="foto-nome">
            <!--<img v-if="this.infoZeladoria.usuario_foto != null" class="os-avatar" :src="infoZeladoria.usuario_foto" alt="zelador">-->
            <!--<img v-else class="os-avatar" src="../../assets/img/face.png" alt="zelador">-->
            <h3 v-if="infoZeladoria.usuario_nome != null" class="nome-zelador">
              {{ this.infoZeladoria.usuario_nome }}
            </h3>
            <h3 v-else class="nome-zelador">Zelador</h3>
          </div>

          <h3 class="nova-ordem-titulo">Monitor Atribuído</h3>
          <div class="foto-nome">
            <h3
              v-if="infoZeladoria.usuario_gestor_nome != null"
              class="nome-zelador"
            >
              {{ this.infoZeladoria.usuario_gestor_nome }}
            </h3>
            <h3 v-else class="nome-zelador">Monitor</h3>
          </div>
        </div>
        <div class="os-map">
          <GmapMap
            class="map"
            ref="googleMap"
            :center="center"
            :zoom="zoom"
            style="height: 278px; width: 800px"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              mapTypeId: mapType,
              gestureHandling: 'greedy',
              fullscreenControl: true,
              disableDefaultUi: true,
              mapTypeId: mapType,
            }"
          >
            <div
              v-for="polygon of polygonSector"
              :key="'polygonsKeepingSector' + polygon.id"
            >
              <GmapPolygon
                ref="polygon"
                :paths="polygon.latlngs"
                :options="polygon.options2"
              />
            </div>
            <GmapPolyline
              ref="polyline"
              v-if="polyline !== null"
              :path="polyline.latlngs"
              :options="polyline.options"
            />
          </GmapMap>
        </div>
      </div>
      <div
        v-if="
          OsInfo.ordem_servico_status_descricao === 'Em Criação' ||
          OsInfo.ordem_servico_status_descricao === 'Revisar'
        "
      >
        <div
          v-if="userType === 2 || this.userType === 3 || this.userType === 1"
          class="botoes-solicitar-os"
        >
          <button @click="ShowModalRascunho()" class="salvar-rascunho">
            Salvar Rascunho
          </button>
          <button @click="ShowModalEnviar()" class="exibir">Enviar</button>
          <div v-if="alertaPoligono === true" class="alertErro">
            *Selecione uma Área de Zeladoria no mapa*
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL --------------------------------------------------------------------------------------------------------------------------------------------------------------------------->

    <Modal class="modal-confirmacao" v-show="modalRascunho" :width="450">
      <template v-slot:header>Deseja salvar as alterações?</template>
      <template v-slot:footer>
        <div class="botoes-confirmacao">
          <button class="botao-cancelar" @click="modalRascunho = false">
            {{ $t("cancel") }}
          </button>
          <button class="botao-salvar" @click="salvarRascunho()">
            {{ $t("save") }}
          </button>
        </div>
      </template>
    </Modal>

    <Modal class="modal-confirmacao" v-show="modalEnviar" :width="500">
      <template v-slot:header
        >Deseja salvar e enviar a Ordem de Serviço?</template
      >
      <template v-slot:footer>
        <div class="botoes-confirmacao">
          <button class="botao-cancelar" @click="modalEnviar = false">
            {{ $t("cancel") }}
          </button>
          <button class="botao-salvar" @click="EnviarOs()">
            {{ $t("save") }}
          </button>
        </div>
      </template>
    </Modal>

    <Modal class="modal-confirmacao" v-show="modalCancelar" :width="500">
      <template v-slot:header>Deseja cancelar a Ordem de Serviço?</template>
      <template v-slot:footer>
        <div class="botoes-confirmacao">
          <button class="botao-cancelar" @click="modalCancelar = false">
            {{ $t("no") }}
          </button>
          <button class="botao-salvar" @click="CancelarOs()">
            {{ $t("yes") }}
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

  <script>
import { formatDate } from "../../utils/date";
import services from "../../services";
import Modal from "../../components/Modal.vue";
import BackArrow from "../../components/BackArrow.vue";
import { formatForGoogleMaps } from "../../utils/geoMaps";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

export default {
  name: "Zeladores",
  components: {
    Modal,
    BackArrow,
  },
  data() {
    return {
      check1: false,
      check2: false,
      check3: false,
      date: new Date(),
      removeModal: false,
      editModal: false,
      userIsActive: false,
      userType: null,
      atividade: 0,
      atividades: [],
      center: {
        lat: -25.43432,
        lng: -49.2638,
      },
      zoom: 2,
      polyline: null,
      mapTypes: [
        { label: this.$t("roadmap"), value: "roadmap" },
        { label: this.$t("sattellite"), value: "satellite" },
        { label: this.$t("hybrid"), value: "hybrid" },
        { label: this.$t("roadmap"), value: "terrain" },
      ],
      mapType: "roadmap",
      polygonSector: [],
      instrucoes: "",
      endereco: "",
      endereco_selecionado: null,
      atividadeEscolhida: false,
      exibirDiv: false,
      exibirErro: false,
      bairro: 0,
      bairros: [],
      bairro_poligono: {},
      pagination: {
        page: 0,
        sortBy: null,
        filter: null,
        order: null,
      },
      bounds: [],
      clickedPoligon: null,
      infoZeladoria: {
        zeladoria_nome: null,
        usuario_nome: null,
      },
      exibirSucesso: false,
      alertaPoligono: false,
      exibirNeutro: false,
      OsInfo: null,
      changeEndereco: false,
      modalRascunho: false,
      modalEnviar: false,
      conteudo_alterado: false,
      modalCancelar: false,
      historicos: [],
      formatDate,
    };
  },
  mounted: async function () {
    const user = this.$store.state.global.user;
    this.userType = user.usuario_gestor_tipo_id;
    await this.getAtividades();
    await this.getBairros();
    await this.getOsInfo();
    await this.historico();
    this.loadingData = false;
  },
  methods: {
    async salvar() {
      this.alertaPoligono = false;
      if (this.exibirSucesso === true) {
        const { errors } = await services.serviceOrder.salvar({
          atividade_id: this.atividade.atividade_id,
          zeladoria_id: this.infoZeladoria.zeladoria_id,
          ordem_servico_instrucao: this.instrucoes,
          ordem_servico_endereco: this.endereco_selecionado,
        });
        if (errors) {
          console.log(errors);
        }
      } else if (this.clickedPoligon != null) {
        const { errors } = await services.serviceOrder.salvar({
          atividade_id: this.atividade.atividade_id,
          zeladoria_id: this.clickedPoligon.id,
          ordem_servico_instrucao: this.instrucoes,
          ordem_servico_endereco: this.endereco_selecionado,
        });
        if (errors) {
          console.log(errors);
        }
      } else {
        this.alertaPoligono = true;
      }
    },
    change() {
      this.conteudo_alterado = true;
      const botao1 = document.getElementById("exibir1");
      if (this.instrucoes.length > 0 && this.endereco.length > 0) {
        botao1.disabled = false;
      } else {
        botao1.disabled = true;
      }
    },
    change2() {
      const botao2 = document.getElementById("exibir2");
      if (this.bairro != 0) {
        botao2.disabled = false;
      } else {
        botao2.disabled = true;
      }
    },
    async exibir() {
      this.exibirNeutro = false;
      this.changeEndereco = true;
      this.exibirErro = false;
      this.exibirDiv = false;
      this.exibirSucesso = false;
      this.clickedPoligon = null;
      (this.infoZeladoria = {
        zeladoria_nome: null,
        usuario_nome: null,
      }),
        (this.conteudo_alterado = true);
      this.polygonSector = [];
      this.endereco_selecionado = this.endereco;
      const { data, errors } = await services.serviceOrder.verificarEndereco({
        endereco: this.endereco,
      });
      if (!errors && !data.zeladoria_id) {
        // Caminho infeliz =[
        this.exibirSucesso = false;

        this.exibirErro = true;
      } else {
        // Caminho feliz =]
        this.exibirErro = false;
        this.clickedPoligon = null;
        this.bairro_poligono = data.zeladoria_limite;
        this.mountPolygon(this.bairro_poligono[0]);
        this.infoZeladoria = data;
        this.exibirSucesso = true;
      }
    },
    async exibir2() {
      this.exibirNeutro = false;
      this.exibirSucesso = false;
      this.polygonSector = [];
      this.exibirDiv = false;
      const { data, errors } = await services.serviceOrder.getPoligono({
        id: this.bairro.bairro_id,
      });
      if (!errors) {
        this.bairro_poligono = data.map((item) => {
          return item;
        });
        this.bairro_poligono.forEach((zeladoria) => {
          this.mountPolygon(
            zeladoria.zeladoria_limite[0],
            zeladoria.zeladoria_id
          );
        });
      }
      this.exibirDiv = true;
    },
    async poligonClick(polygon) {
      this.clickedPoligon = polygon;
      this.polygonSector.map((item) => {
        if (item.id === polygon.id) {
          item.options = {
            strokeColor: "#348534",
            fillColor: "#20d820",
          };
        } else {
          item.options = {
            strokeColor: "#A30BB2",
            fillColor: "#BE21CD",
          };
        }
      });
      const { data, errors } = await services.serviceOrder.getInfoPoligono({
        id: this.clickedPoligon.id,
      });
      if (!errors) {
        this.infoZeladoria = data;
      }
    },
    async handleSort(sort) {
      this.fields.forEach((f) => {
        f.key !== sort.key
          ? (f.sortDirection = null)
          : (f.sortDirection = sort.sortDirection);
      });
      this.pagination.sortBy = sort.key;
      this.pagination.order = sort.sortDirection;
      this.pagination.page = 0;
      await this.getOrders(this.pagination);
    },
    async getAtividades() {
      const { data, errors } = await services.serviceOrder.getAtividade();
      if (!errors) {
        this.atividades = data.map((item) => {
          return item;
        });
      }
    },
    async getBairros() {
      const { data, errors } = await services.serviceOrder.getBairro(
        this.pagination
      );
      if (!errors) {
        this.bairros = data.map((item) => {
          return item;
        });
      }
    },
    correçãoErro() {
      formatForGoogleMaps();
    },
    mountPolygon(poligono, id) {
      if (poligono !== "") {
        const coordinatesJSONParse = poligono;
        let bairro_poligono = {
          latlngs: formatForGoogleMaps(coordinatesJSONParse),
          options: {
            strokeColor: "#A30BB2",
            fillColor: "#BE21CD",
          },
          options2: {
            strokeColor: "#348534",
            fillColor: "#20d820",
          },
          id,
        };
        bairro_poligono.latlngs.map((item) => {
          this.bounds.push(item);
        });

        this.polygonSector.push(bairro_poligono);
      }
      this.fitBoundsGoogle();
    },
    fitBoundsGoogle() {
      setTimeout(() => {
        this.$refs.googleMap.$mapPromise.then(() => {
          const b = new window.google.maps.LatLngBounds();
          for (let i of this.bounds) {
            b.extend({
              lat: i.lat,
              lng: i.lng,
            });
          }
          this.$refs.googleMap.fitBounds(b);
        });
      }, 100);
    },
    async getOsInfo() {
      const { data, errors } = await services.serviceOrder.getOsInfo({
        id: this.$route.params.id,
      });
      if (!errors) {
        this.OsInfo = data;
        this.atividade = {
          atividade_nome: this.OsInfo.atividade_nome,
          atividade_id: this.OsInfo.atividade_id,
        };
        this.instrucoes = this.OsInfo.ordem_servico_instrucao;
        this.endereco = this.OsInfo.ordem_servico_endereco;
        this.endereco_selecionado = this.OsInfo.ordem_servico_endereco;
        this.infoZeladoria = data;
        this.bairro_poligono = data.zeladoria_limite;
        this.mountPolygon(this.OsInfo.zeladoria_limite[0]);
        this.exibirNeutro = true;
      }
    },
    async historico() {
      const { data, errors } = await services.serviceOrder.historico({
        id: this.$route.params.id,
      });
      if (!errors) {
        this.historicos = data;
      }
    },
    async salvarRascunho() {
      this.alertaPoligono = false;
      if (this.changeEndereco === true) {
        if (this.exibirSucesso === true) {
          const { errors } = await services.serviceOrder.salvarRascunho({
            atividade_id: this.atividade.atividade_id,
            zeladoria_id: this.infoZeladoria.zeladoria_id,
            ordem_servico_instrucao: this.instrucoes,
            ordem_servico_endereco: this.endereco_selecionado,
            ordem_servico_id: this.OsInfo.ordem_servico_id,
          });
          this.modalRascunho = false;
          if (errors) {
            console.log(errors);
          }
        } else if (this.clickedPoligon != null) {
          const { errors } = await services.serviceOrder.salvarRascunho({
            atividade_id: this.atividade.atividade_id,
            zeladoria_id: this.clickedPoligon.id,
            ordem_servico_instrucao: this.instrucoes,
            ordem_servico_endereco: this.endereco_selecionado,
            ordem_servico_id: this.OsInfo.ordem_servico_id,
          });
          this.modalRascunho = false;
          if (errors) {
            console.log(errors);
          }
        } else {
          this.alertaPoligono = true;
        }
      } else {
        const { errors } = await services.serviceOrder.salvarRascunho({
          atividade_id: this.atividade.atividade_id,
          zeladoria_id: this.infoZeladoria.zeladoria_id,
          ordem_servico_instrucao: this.instrucoes,
          ordem_servico_endereco: this.endereco_selecionado,
          ordem_servico_id: this.OsInfo.ordem_servico_id,
        });
        this.modalRascunho = false;
        if (errors) {
          console.log(errors);
        }
      }
    },
    async EnviarOs() {
      await this.salvarRascunho();
      const { errors } = await services.serviceOrder.enviarOs({
        ordem_servico_id: this.OsInfo.ordem_servico_id,
      });
      if (errors) {
        console.log(errors);
      }
      this.modalEnviar = false;
      this.$router.push("/ordens-de-servico");
    },
    async CancelarOs() {
      const { errors } = await services.serviceOrder.cancelarOs({
        id: this.OsInfo.ordem_servico_id,
      });
      if (errors) {
        console.log(errors);
      }
      this.$router.push("/ordens-de-servico");
    },
    ShowModalRascunho() {
      this.modalRascunho = true;
    },
    ShowModalEnviar() {
      this.modalEnviar = true;
    },
    ShowModalCancelar() {
      this.modalCancelar = true;
    },
  },
};
</script>
  <style lang="scss">
.nova-ordem-titulo {
  font-family: "Montserrat";
  font-size: 20px;
  color: #565e73;
  margin: 24px 0px;
}
.nova-ordem {
  margin-bottom: 32px;
  margin-top: 64px;
}
.atividade-input {
  padding: 12px 16px;
  width: 600px !important;
  background: #ffffff;
  border: 1px solid #c6c9d0;
  border-radius: 12px;
  outline: none;
}
.instrucoes-input {
  height: 160px !important;
  width: 100%;
  border: 1px solid #c6c9d0;
  border-radius: 12px;
  padding: 12px 16px;
  outline: none;
}
.exibir {
  color: white;
  background: #003366;
  border-radius: 8px;
  padding: 8px 16px;
}
.zeladoria-atribuida {
  text-align: center;
  align-items: center;
  padding: 2px 6px;
  background: #dddee3;
  border-radius: 30px;
  width: 80px;
  color: #131e3b;
  margin-bottom: 26px;
}
.foto-nome {
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
}
.os-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 16px;
}
.nome-zelador {
  display: flex;
  color: #131e3b;
  font-size: 14px;
  font-family: "Open Sans";
  margin: 0px;
  justify-content: center;
  align-items: center;
}
.box-zeladdoria {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.salvar-rascunho {
  padding: 8px 16px;
  color: #131e3b;
  text-align: center;
  font-family: "Open Sans";
  margin-right: 32px;
  border-radius: 8px;
  background: #ffffff;
}
.botoes-solicitar-os {
  display: flex;
  flex-direction: row;
  margin-top: 32px;
}
.erro-endereco {
  display: flex;
  flex-direction: row;
  border: solid 3px #d3341d;
  border-radius: 8px;
  height: 124px;
  align-items: center;
  margin: 24px 0px;
}
.barra-vermelha {
  width: 12px;
  background-color: #d3341d;
  height: 100%;
}
.x-vermelho {
  width: 24px;
  height: 24px;
  margin: 0px 20px;
}
.nova-ordem-erro {
  font-family: "Montserrat";
  color: #112c66;
  font-size: 16px;
}
.nova-ordem-erro2 {
  font-family: "Open Sans";
  color: #565e73;
  font-size: 14px;
}
textarea::placeholder {
  color: lightgray;
}
input::placeholder {
  color: lightgray;
}
.input-wrapper {
  margin: 0px !important;
  padding: 0px;
}
button:disabled {
  background: #b8c5d3;
}
.alertErro {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  color: red;
  margin: 0px 18px;
  height: 41px;
}
.status_editar {
  font-size: 14px;
  margin-left: 44px;
}
.modal-confirmacao {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.botoes-confirmacao {
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  width: 100%;
}
.botao-salvar {
  padding: 12px;
  width: 100px;
  background-color: #7b9e1e;
  color: white;
  border-radius: 8px;
}
.botao-cancelar {
  padding: 12px;
  width: 100px;
  background-color: #a92a17;
  color: white;
  border-radius: 8px;
}
.div-titulo {
  display: flex;
  justify-content: space-between;
}
.botao-cancelar-solicitacao {
  background-color: #d3341d;
  border: none;
  color: white;
  padding: 3px 14px;
  border-radius: 7px;
}
.historico-card {
  display: flex;
  flex-direction: column;
  border: 1px solid lightgray;
  padding: 12px;
  border-radius: 12px;
}
.historico-usuario {
  display: flex;
  padding: 6px;
}
.historico-nome {
  color: #00b1eb;
  font-size: 14px;
  margin-right: 12px;
}
.historico-descricao {
  display: flex;
  color: #565e73;
  font-size: 12px;
  justify-content: center;
  align-items: center;
}
.status_historico {
  font-size: 12px;
  margin-left: 16px;
}
.log-info {
  border: 1px solid #dddee3;
  border-radius: 8px;
  padding: 12px;
  color: #565e73;
  font-size: 14px;
  font-family: "Open Sans";
  background-color: #f3f4f5;
  margin-top: 16px;
}
.historico-data {
  color: #131e3b;
  margin-top: 28px !important;
  margin-bottom: 18px !important;
  margin-left: 8px;
  font-size: 16px;
  font-family: "Montserrat";
  font-weight: bold;
}
.historico-Os {
  margin-top: 64px;
}
</style>
